<script setup>

// Props
const props = defineProps({
  banner: {
    type: Object,
    default: () => ({})
  }
})
const bannerHtml = computed(() => {
  const html = props.banner?.banner?.bannerText?.html
  if (!html) return ''
  return html.replace(/<img(?![^>]*loading=)/g, '<img loading="lazy" decoding="async" fetchpriority="low"')
})
</script>

<!-- -------------------------------------------------------------------------------------------------
    Template
------------------------------------------------------------------------------------------------- -->

<template>
  <section v-if="props.banner?.banner?.bannerText?.html" class="page-top-banner">
    <div class="container">
      <div v-html="bannerHtml"
               class="banner__text"></div>

      <a v-if="props.banner.banner?.linkTitle?.url && props.banner.banner?.linkTitle?.title"
        :href="props.banner.banner?.linkTitle.url"
        :aria-label="props.banner.banner?.linkTitle?.title"
        :title="props.banner.banner?.linkTitle?.title"
        :target="props.banner.banner?.linkTitle?.target || null"
        class="banner__link">
        <span class="banner__link-text">
          {{ props.banner.banner?.linkTitle?.title }}
        </span>
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="9" viewBox="0 0 12 9" fill="none">
          <path d="M5.54681 9L9.12766 4.94043L0 4.94043V4.05958L9.12766 4.05957L5.54681 0H6.48511L12 4.5L6.48511 9H5.54681Z" fill="white"/>
        </svg>
      </a>
    </div>
  </section>
</template>

<!-- -------------------------------------------------------------------------------------------------
    Styling
------------------------------------------------------------------------------------------------- -->

<style scoped>

.page-top-banner {
  max-height: 160px;
  transition: max-height .2s ease-in-out;
  overflow: hidden;
  color: var(--color-black);
  background: var(--color-lime, #f2ff66);
}

.container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  min-height: 40px;
  padding: 10px 16px 11px;
  gap: 12px;
}

.banner__text {
  font-size: 14px;
  font-weight: 500;
  line-height: 136%;
  letter-spacing: -0.26px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  color: var(--color-black);
  min-width: 0;
}

.banner__text :deep(p) {
  margin: 0;
}

.banner__text :deep(p:last-child) {
  width: auto;
}

.banner__text :deep(strong) {
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  letter-spacing: inherit;
}

.banner__text :deep(figure) {
  margin-left: 6px;
  transform: translateY(-1px);
}

.banner__text :deep(img) {
  height: 14px;
  width: auto;
  margin-top: 2px;
}

.banner__link {
  display: flex;
  align-items: center;
  color: var(--color-black);
  flex-shrink: 0;
  margin-left: 0;
}

.banner__link-text {
  font-size: 14px;
  font-weight: 500;
  line-height: 138%;
  letter-spacing: -0.26px;
  position: relative;
  text-decoration: underline;
  text-decoration-color: currentColor;
  text-underline-offset: 1px;
}

.banner__link-text::after {
  content: none;
}

.banner__link svg {
  display: none;
}

@media (min-width: 768px) {
  .container {
    padding: 10px 0 11px;
    flex-wrap: nowrap;
    gap: 48px;
  }

  .banner__text :deep(strong) {
    display: inline;
    height: auto;
  }

  .banner__text :deep(p:last-child) {
    margin-left: 0;
  }

  .banner__link {
    margin-top: 0;
    margin-left: 0;
  }

}

:global(.page:has(.layout-header-mobile .mobile-navigation) .page-top-banner) {
  max-height: 0;
}

</style>